; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Components/Carousel',["jquery", "eventManager"], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager")) :
    console && console.error('Carousel does not support non-amd script loading.');
}(this/* window */, function ($, eventManager) {

    function Carousel(scope, carouselId) {
        var self = this;
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: true, value: $(scope), writable: !1 });
        Object.defineProperty(this, 'lastDirection', { enumerable: !1, value: void 0, writable: !0 });

        self.buildIndicator(carouselId);
        self.fallbackIndicators(carouselId);

        this.$scope.on('slide.bs.carousel', this._onBeforeChangeSlide.bind(this));
        this.$scope.on('slid.bs.carousel', this._onAfterChangeSlide.bind(this));
    }


    Carousel.prototype.buildIndicator = function (carouselId) {
        var slides = $('.carousel-inner .item', this.$scope).map(function (i) {
            return "<li data-target=\"#" + carouselId + "\" data-slide-to=\"" + i + "\"" + (!i ? " class=\"active\"" : "") + "><!-- --></li>";
        }).get().join("");

        if (slides.length > 0) {
            this.$scope.prepend("<ol class=\"carousel-indicators\">" + slides + "</ol>");
        }
    }

    Carousel.prototype.fallbackIndicators = function (carouselId) {
        var $carousel = this.$scope;
        var id = carouselId;
        var relatedIndicators = $('li[data-target="#' + id + '"]', this.$scope);
        $carousel.on('slid.bs.carousel', function (e) {
            var index = $carousel.find('.carousel-inner .item').index($carousel.find('.carousel-inner .active'));
            relatedIndicators.removeClass('active');
            relatedIndicators.filter('[data-slide-to="' + index + '"]').addClass('active');
        });
    }

    /**
     * Notify the world about slide is going to be changed
     * @param {jQuery.Event} event from bootstrap carousel 
     */
    Carousel.prototype._onBeforeChangeSlide = function (e) {
        this.lastDirection = e.direction;
        $(this).trigger('beforeChange.slider', [this, e.direction]);
    }

    /**
     * Notify the world about slide was changed
     * @param {jQuery.Event} event from bootstrap carousel 
     */
    Carousel.prototype._onAfterChangeSlide = function (e) {
        this.lastDirection = e.direction;
        $(this).trigger('afterChange.slider', [this, e.direction]);
    }

    Carousel.init = function(args) {
        if (args.IsEditorEditing) return null;

        var carousel = new Carousel(args.scope, args.CarouselId || []);

        return carousel;
    }

    return Carousel;
}));

